import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const NotFound: React.FC = () => {
  return (
    <PageTemplate
      title="404 - Page Not Found"
      description="The page you're looking for doesn't exist"
    >
      <a 
        href="/" 
        className="inline-flex items-center px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
      >
        Go back home
      </a>
    </PageTemplate>
  );
};

export default NotFound;